import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const authGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  const isAuth = authService.isAuthenticated();
  const hasProfile = authService.hasAdminProfile();

  if (isAuth && hasProfile) {
    return true;
  }

  router.navigate(['/login']);
  return false;
};
